<template>
  <v-container>
    <view-intro heading="Аxx цагийн гүйцэтгэл" />
    <v-row v-for="(semester, semindex) in semesters" :key="semindex">
      <h3>
        {{ semester.startDate }} - {{ semester.endDate }} /
        {{ semester.shortName }}
        <span v-if="semester.lessons != null"
          >({{ semester.lessons.length }})</span
        >
      </h3>
      <ATsagTable
        :lessons="semester.lessons"
        :schoolPath="yyschool"
        :semester="semester"
        v-bind="$attrs"
      ></ATsagTable>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({
    schools: null,
    semesters: null,
    lessons: null,
  }),
  components: {
    ATsagTable: () => import("./ATsagTable.vue"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
    this._setupp();
  },

  methods: {
    _setupp2() {
      var query = fb.db
        .collection(this.yyschool + "/lessons")
        // .where("semesterRef", "==", semester.ref)
        .orderBy("createdAt", "desc");
      if (this.userProfile.role == "teacher") {
        query = query.where("teacherRef", "==", this.userProfile.ref);
      }

      query.onSnapshot((querySnapshot) => {
        this.lessons = [];
        var counter = 0;
        querySnapshot.forEach((doc) => {
          counter++;
          let lesson = doc.data();
          lesson.ref = doc.ref;
          lesson.id = doc.id;
          lesson.index = counter;
          lesson.lessonStandard2 = null;
          var xx = fb.db.doc(
            "/schools/YJHjHWUGDok8teDhDIKX/xschoolyears/gbiwjWvgIL6cZnfHNVtU/semesters/ES3wbpPjreFeo17jaSwp"
          );
          // console.log(xx);
          lesson.ref.update({
            semesterRef: fb.db.doc(
              "/schools/YJHjHWUGDok8teDhDIKX/xschoolyears/gbiwjWvgIL6cZnfHNVtU/semesters/ES3wbpPjreFeo17jaSwp"
            ),
          });
          //schools/YJHjHWUGDok8teDhDIKX/semesters/m43yJlkKiie39oDCrPjV
          console.log(lesson.ref.path);
          if (lesson.lessonStandardRef) {
            lesson.lessonStandardRef.get().then((lessonStandard) => {
              if (lessonStandard.exists)
                lesson.lessonStandard2 = lessonStandard.data();
            });
          }
          lesson.lessonGroups = null;
          lesson.ref
            .collection("lesson-groups")
            .orderBy("index", "asc")
            .where("deleted", "==", false)
            .onSnapshot((docs) => {
              lesson.lessonGroups = [];
              docs.forEach((doc) => {
                let gc = doc.data();
                gc.ref = doc.ref;
                gc.id = doc.id;
                gc.teachedTopics = null;
                gc.ref.collection("teached-topics").onSnapshot((docs) => {
                  gc.teachedTopics = [];
                  docs.forEach((doc) => {
                    let teachedTopic = doc.data();
                    teachedTopic.id = doc.id;
                    teachedTopic.ref = doc.ref;
                    // console.log(gc.ref.path, teachedTopic.ref.path);
                    gc.teachedTopics.push(teachedTopic);
                  });
                });
                lesson.lessonGroups.push(gc);
              });
            });

          this.lessons.push(lesson);
        });
      });
    },
    _setupp() {
      fb.db
        .collection(
          this.yyschool + "/xschoolyears/gbiwjWvgIL6cZnfHNVtU/semesters"
        )
        .where("running", "==", true)
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          {
            this.semesters = [];

            querySnapshot.forEach((doc) => {
              let semester = doc.data();
              semester.id = doc.id;
              semester.ref = doc.ref;
              semester.lessons = null;

              var query = fb.db
                .collection(this.yyschool + "/lessons")
                .where("semesterRef", "==", semester.ref)
                .orderBy("createdAt", "desc");
              if (this.userProfile.role == "teacher") {
                query = query.where("teacherRef", "==", this.userProfile.ref);
                console.log(this.userProfile.ref.path);
              }

              query.onSnapshot((querySnapshot) => {
                semester.lessons = [];
                var counter = 0;
                querySnapshot.forEach((doc) => {
                  counter++;
                  let lesson = doc.data();
                  lesson.ref = doc.ref;
                  lesson.id = doc.id;
                  lesson.index = counter;
                  lesson.lessonStandard2 = null;
                  lesson.lessonGroups = null;
                  lesson.lectureLessonGroups = null;
                  lesson.seminarLessonGroups = null;
                  lesson.homeworkLessonGroups = null;

                  if (lesson.lessonStandardRef) {
                    lesson.lessonStandardRef.get().then((lessonStandard) => {
                      if (lessonStandard.exists)
                        lesson.lessonStandard2 = lessonStandard.data();
                    });
                  }

                  //reading contents...
                  lesson.seminars = null
                  lesson.ref.collection("seminars").onSnapshot((docs)=>{
                    lesson.seminars = []
                    docs.forEach((doc)=>{
                      let seminar = doc.data()
                      seminar.id = doc.id
                      seminar.ref = doc.ref
                      console.log(seminar.ref.path)
                      lesson.seminars.push(seminar)
                    })
                  })

                  lesson.ref
                    .collection("lesson-groups")
                    .orderBy("index", "asc")
                    .where("deleted", "==", false)
                    .onSnapshot((docs) => {
                      lesson.lessonGroups = [];
                      docs.forEach((doc) => {
                        let gc = doc.data();
                        gc.ref = doc.ref;
                        gc.id = doc.id;
                        gc.teachedTopics = null;
                        gc.ref
                          .collection("teached-topics")
                          .onSnapshot((docs) => {
                            gc.teachedTopics = [];
                            docs.forEach((doc) => {
                              let teachedTopic = doc.data();
                              teachedTopic.id = doc.id;
                              teachedTopic.ref = doc.ref;
                              console.log(gc.ref.path, teachedTopic.ref.path);
                              gc.teachedTopics.push(teachedTopic);
                            });
                            console.log(
                              "--------------------------------------------------------------"
                            );
                          });
                        lesson.lessonGroups.push(gc);
                      });
                    });

                  lesson.ref
                    .collection("lecture-topic-groups")
                    .orderBy("index", "asc")
                    .where("deleted", "==", false)
                    .onSnapshot((docs) => {
                      lesson.lectureLessonGroups = [];
                      docs.forEach((doc) => {
                        let gc = doc.data();
                        gc.ref = doc.ref;
                        gc.id = doc.id;

                        lesson.lectureLessonGroups.push(gc);
                      });
                    });

                  //schools/YJHjHWUGDok8teDhDIKX/lessons/lYecClBewZtq7vGxPB5B/seminar-topic-groups/gIyAlXymxPAtrhHFX5RF/teached-topics/EWh5OtQZVcpyYDFxlcjL
                  lesson.ref
                    .collection("seminar-topic-groups")
                    .orderBy("index", "asc")
                    .where("deleted", "==", false)
                    .onSnapshot((docs) => {
                      lesson.seminarLessonGroups = [];
                      docs.forEach((doc) => {
                        let gc = doc.data();
                        gc.ref = doc.ref;
                        gc.id = doc.id;
                        console.log(gc.ref.path)
                        lesson.seminarLessonGroups.push(gc);
                      });
                    });
                  lesson.ref
                    .collection("homework-topic-groups")
                    .orderBy("index", "asc")
                    .where("deleted", "==", false)
                    .onSnapshot((docs) => {
                      lesson.homeworkLessonGroups = [];
                      docs.forEach((doc) => {
                        let gc = doc.data();
                        gc.ref = doc.ref;
                        gc.id = doc.id;

                        lesson.homeworkLessonGroups.push(gc);
                      });
                    });
                  semester.lessons.push(lesson);
                });
              });

              this.semesters.push(semester);
            });
          }
        });
    },
    _read() {},
  },
};
</script>
